export default __webpack_public_path__ + "static/media/advanced-iphone.f38f2961.png";